import { useEffect, RefObject } from 'react';

// Add Vimeo type declaration
declare global {
    interface Window {
        Vimeo?: {
            Player: new (element: HTMLElement | string) => {
                on: (event: string, callback: () => void) => void;
            };
        };
    }
}

interface UseVimeoPlayerProps {
    containerRef: RefObject<HTMLDivElement>;
    videoId: string;
    onPlay?: () => void;
}

export const useVimeoPlayer = ({
    containerRef,
    videoId,
    onPlay
}: UseVimeoPlayerProps) => {
    useEffect(() => {
        // Wait for Vimeo API to load
        const handleVimeoApiLoad = () => {
            if (containerRef.current) {
                const iframe = containerRef.current.querySelector('iframe');
                if (iframe) {
                    // @ts-ignore - Vimeo Player API
                    const player = new window.Vimeo.Player(iframe);
                    player.on('play', () => {
                        onPlay?.();
                    });
                }
            }
        };

        // Check if Vimeo API is already loaded
        if (window.Vimeo) {
            handleVimeoApiLoad();
        } else {
            // Wait for Vimeo API to load
            const interval = setInterval(() => {
                if (window.Vimeo) {
                    handleVimeoApiLoad();
                    clearInterval(interval);
                }
            }, 500);
            return () => clearInterval(interval);
        }
    }, [containerRef, videoId, onPlay]);
};
